import {lazy} from '@aboutyou/lazy-imports';
import {useLogHydrationFailed} from '@aboutyou/logic-components';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

const LoadingSkeletonWithHydrationFailedLogging: React.FC = () => {
  useLogHydrationFailed({context: 'CategoryPageSkeleton'});
  return <LoadingPageSpinner />;
};

export const Category = lazy(
  () => import('./Category.eager').then(mod => ({default: mod.Category})),
  {
    fallback: <LoadingSkeletonWithHydrationFailedLogging />,
    aboveTheFold: true,
  },
);
